import { useState } from "react";
import "./AdminDonations.scss";
import {
  useGetAllDonationsQuery,
  useGetDonationStatsQuery,
  useGetStripeBalanceQuery,
} from "../../features/api/donationApiSlice";

const formatMoney = (cents = 0) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);

export default function Donations() {
  const [page, setPage] = useState(1);

  const { data: stats } = useGetDonationStatsQuery();
  const { data, isLoading } = useGetAllDonationsQuery({ page, limit: 10 });
  const { data: balance } = useGetStripeBalanceQuery();

  const availableBalance =
    balance?.available?.reduce((sum, item) => sum + item.amount, 0) || 0;

  const pendingBalance =
    balance?.pending?.reduce((sum, item) => sum + item.amount, 0) || 0;

  return (
    <section className="admin-donations">
      <div className="admin-donations__header">
        <h1>Fuel Donations</h1>
        <p>Track fuel support, donor notes, and estimated miles funded.</p>
      </div>

      <div className="donation-stats">
        <article>
          <span>Total Donations</span>
          <strong>{formatMoney(stats?.totalAmountInCents)}</strong>
        </article>

        <article>
          <span>Miles Fueled</span>
          <strong>{stats?.totalMiles || 0}</strong>
        </article>

        <article>
          <span>Donation Count</span>
          <strong>{stats?.totalDonations || 0}</strong>
        </article>

        <article>
          <span>Stripe Available</span>
          <strong>{formatMoney(availableBalance)}</strong>
        </article>

        <article>
          <span>Stripe Pending</span>
          <strong>{formatMoney(pendingBalance)}</strong>
        </article>
      </div>

      <div className="donation-table-card">
        <h2>Recent Donations</h2>

        {isLoading ? (
          <p>Loading donations...</p>
        ) : (
          <>
            <div className="donation-table">
              <table>
                <thead>
                  <tr>
                    <th>Donor</th>
                    <th>Email</th>
                    <th>Amount</th>
                    <th>Miles</th>
                    <th>Type</th>
                    <th>Message</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>

                <tbody>
                  {data?.items?.map((donation) => (
                    <tr key={donation._id}>
                      <td>{donation.donorName}</td>
                      <td>{donation.donorEmail || "—"}</td>
                      <td>{formatMoney(donation.amountInCents)}</td>
                      <td>{donation.calculatedMiles}</td>
                      <td>{donation.fuelOptionType}</td>
                      <td>{donation.message || "—"}</td>
                      <td>{donation.status}</td>
                      <td>
                        {new Date(donation.createdAt).toLocaleDateString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* <div className="donation-pagination">
              <span>
                Page {data?.page || 1} of {data?.totalPages || 1}
              </span>

              {data?.totalPages > 1 && (
                <div>
                  <button
                    disabled={page <= 1}
                    onClick={() => setPage((prev) => prev - 1)}
                  >
                    Prev
                  </button>

                  <button
                    disabled={page >= data?.totalPages}
                    onClick={() => setPage((prev) => prev + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </div> */}

            <div className="donation-pagination">
              <span>
                Page {data?.page || 1} of {data?.totalPages || 1}
              </span>

              <div>
                <button
                  disabled={page <= 1}
                  onClick={() => setPage((prev) => prev - 1)}
                >
                  Prev
                </button>

                <button
                  disabled={page >= data?.totalPages}
                  onClick={() => setPage((prev) => prev + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
